import React from 'react';
import './FullScreenLoader.css';

interface FullScreenLoaderProps {
  progress?: number;
  message?: string;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ progress, message }) => (
  <div className="loader-overlay">
    <div className="loader" />
    <span>{message || 'Carregando...'}</span>
    {progress !== undefined && (
      <div className="progress-container">
        <div className="progress-bar" style={{ width: `${Math.min(100, Math.max(0, progress))}%` }} />
        <span className="progress-text">Enviando imagens... {Math.round(progress)}%</span>
      </div>
    )}
  </div>
);

export default FullScreenLoader;
